var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoBook(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/filled/uniq/check_book") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/filled/uniq/check_book",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_book",
    transform: "translate(5.000000, 3.000000)",
    fill: "#27AE60",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.948375 L0,20.051668 C0,21.1272188 0.896161765,22 2.00183824,22 L3,22 L3,0 L2.00183824,0 C0.896161765,0 0,0.872824219 0,1.948375 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0865964,0 L4,0 L4,22 L16.0865964,22 C17.1434699,22 18,21.1272188 18,20.051625 L18,1.948375 C18,0.872824219 17.1434699,0 16.0865964,0 Z M10.6468373,15.6030273 L6.6684759,15.6030273 L6.7501988,14.5234375 C6.82399398,14.1132148 7.08885542,13.7647813 7.46048795,13.5915313 L9.06024096,12.9248711 C9.32645181,12.8000039 9.49774096,12.5280977 9.49774096,12.2286484 L9.49774096,11.9889688 C9.49774096,11.8754883 9.47927108,11.7626953 9.44372289,11.6552734 C9.44372289,11.6552734 8.43694578,10.2869766 8.43694578,9.02545703 C8.43694578,7.448375 9.42660241,6.43457031 10.6468373,6.43457031 C11.8684217,6.43457031 12.8580783,7.448375 12.8580783,9.02545703 C12.8580783,10.2869766 11.8513012,11.6552734 11.8513012,11.6552734 C11.8144036,11.7626953 11.7972831,11.8754883 11.7972831,11.9889688 L11.7972831,12.2286484 C11.7972831,12.5280977 11.9672651,12.8000039 12.2347831,12.9248711 L13.8345783,13.5915742 C14.2062108,13.7647813 14.4710723,14.1132578 14.5448675,14.5234805 L14.626506,15.6030273 L10.6468373,15.6030273 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBook);
export default __webpack_public_path__ + "static/media/ico_book.77412682adf1d138709ee1993cf8c8b7.svg";
export { ForwardRef as ReactComponent };